import type { HexColor } from "../hex-color/hex-color";
import type { RGBA } from "../rgba-color/rgba-color";

const hexToRgba = (hex: HexColor): RGBA => {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, "") as HexColor;

    // Parse the r, g, b values
    let r: number;
    let g: number;
    let b: number;
    let a: number | undefined = undefined;
    if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
    } else if (hex.length === 8) {
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
        a = parseInt(hex.substring(6, 8), 16);
    } else {
        throw new Error("Invalid hex color");
    }

    // Default alpha to
    // full opacity if not set
    if (typeof a !== "number") a = 255;

    return {
        red: r,
        green: g,
        blue: b,
        alpha: a / 255, // Set alpha to a percentage
    };
};

export { hexToRgba };
